import { ButtonGroup } from "@mui/material";
import React from "react";
import { useComponentSelection } from "../../Hooks/useComponentSelection";
import { ButtonGroupModel } from "../../Models/ButtonGroupModel";
import ComponentFactory from "../ComponentFactory";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";

export type ButtonGroupComponentProps = IComponentProps<ButtonGroupModel>;

const ButtonGroupComponent: React.FC<ButtonGroupComponentProps> = ({ component, context, componentPath = [] }) => {
  const componentLayoutSx = getComponentLayout(component);

  const selectionProps = useComponentSelection({
    component,
    componentPath,
    isContainer: true,
    isEmpty: !component.Children || component.Children.length === 0,
  });

  return (
    <ButtonGroup sx={componentLayoutSx} variant={component.Variant} size={component.Size} color={component.Color} {...selectionProps}>
      {component.Children?.map((child) => (
        <ComponentFactory key={child.Id} parent={component} component={child} context={context} componentPath={[...componentPath, child.Id]} />
      ))}
    </ButtonGroup>
  );
};

export default ButtonGroupComponent;
